import _get from 'lodash/get';

export const getZoomPlanType = state => _get(state, 'zoom.planType', null);

export const getZoomMeeting = state => _get(state, 'zoom.meeting');

export const getConnectionSettings = state => _get(state, 'zoom.connectionSettings', {});



// WEBPACK FOOTER //
// ./src/selectors/zoom/zoomSelectors.js